
import Header from "../models/header";
import Options from "@/models/options";
import * as repliesAPI from "@/api/replies";
import Vue from "vue";
import {Reply} from "@/api/types/Reply";

export default Vue.extend({
  name: "FormRepliesList",
  data() {
    return {
      loading: false as boolean,
      options: {} as Options,
      formId: 0 as number,
      formUID: "" as string,
      total: 0 as number,
      search: "" as string,
      sortBy: "updatedAt",
      sortDesc: true,
      replies: [] as Reply[]
    };
  },
  watch: {
    options: {
      handler(): void {
        this.getReplies();
      },
      deep: true,
    },
  },
  created() {
    this.formId = parseInt(this.$route.params.id);
    this.formUID = this.$route.params.uid;
    this.getReplies();
  },
  methods: {
    getReplies() {
      this.loading = true;
      if (this.options.sortBy) {
          this.sortBy = this.options.sortBy[0];
      }
      if (this.options.sortDesc) {
        this.sortDesc = this.options.sortDesc[0];
      }
      let limit = this.options.itemsPerPage;
      let skip =
          (this.options.page ? this.options.page - 1 : 0) *
          (this.options.itemsPerPage ?? 0);
      if (!limit || limit < 0) {
        limit = 10;
      }
      repliesAPI
          .list(limit, skip, this.formId, this.sortBy, this.sortDesc)
          .then((replies: any) => {
            this.total = replies.total;
            this.replies = replies.data;
            this.loading = false;
          });
    },
    editReply(id: number) {
      this.$router.push(`/form-reply/${this.formUID}/${id}`).catch((err) => {
        console.log(err);
      });
    },
  },
  computed: {
    headers: {
      set() {
        return [];
      },
      get() {
        return [
          new Header(this.$t("forms.replies.headers.id"), "id"),
          new Header(this.$t("forms.replies.headers.createdAt"), "createdAt"),
          new Header(this.$t("forms.replies.headers.updatedAt"), "updatedAt"),
          new Header(this.$t("forms.replies.headers.createdBy"), "createdBy"),
          new Header(this.$t("forms.replies.headers.actions"), "actions", false),
        ];
      },
    },
  },
});
